import React, { useState, useEffect } from 'react';

import { animateScroll as scrolls } from 'react-scroll';

import { AiOutlineArrowUp } from 'react-icons/ai';

import './styles.css';


const ScrollToTop = () => {
  const [scroll, setScroll] = useState(false);
  useEffect(() => {
  window.addEventListener("scroll", handleScroll);
  return () => window.removeEventListener("scroll", handleScroll);
  }, [])
  const handleScroll = () => {
  setScroll(window.pageYOffset < 600);
  };
  const scrollToTop = () => {
    scrolls.scrollToTop();
  };
  return (
    <div
    className={scroll? "d-none": "scrolltop text-white pointer"}
    onClick={scrollToTop}>
      <AiOutlineArrowUp size={60} />
    </div>
  );
}

export default ScrollToTop;